<template>
  <div class="outer-wrapper">
    <div class="inner-page animate__animated animate__slideInRight">
      <b-container fluid>
        <div class="card card-details">
          <div class="card-body p-3">
            <div class="row">
              <div class="col-8 pr-0">
                <span class="d-block mb-2 f-12"> {{ lead.lead_number }} </span>
                <h3 class="broker-name">{{ lead.name }}</h3>
                <span class="firm-name">{{ lead.firm_name }}</span>
              </div>
              <div class="col-4 pl-0 text-right">
                <a class="label-call" :href="`tel:${lead.phone}`">
                  <img src="@/assets/phone.svg" width="14" class="mr-2" alt="..." /></a>
              </div>
            </div>
            <div class="row">
              <div class="col-8 pr-0">
                <ul class="list-unstyled mt-1 mb-0">
                  <li class="media mb-1">
                    <img src="@/assets/phone.svg" width="14" class="mr-2" alt="..." />
                    <div class="media-body">
                      <a class="mt-0 mb-1" :href="`tel:${lead.phone}`">{{ lead.phone }}</a>
                    </div>
                  </li>
                  <li class="media mb-1">
                    <img src="@/assets/email.svg" width="14" class="mr-2" alt="..." />
                    <div class="media-body">
                      <a class="mt-0 mb-1 " v-if="lead.email" :href="`mailto:${lead.email}`">{{ lead.email }}</a>
                      <p class="mt-0 mb-0" v-if="!lead.email"> -- </p>
                    </div>
                  </li>
                  <li class="media mb-1 addressFeild">
                    <img v-if="lead.locality_name || lead.address" src="@/assets/mappin.svg" width="14" class="mr-2" alt="..." />
                    <div class="media-body">
                      <p class="mt-0 mb-1">{{ lead.locality_name }}</p>
                      <p class="m-0">
                        {{ lead.address }}
                      </p>
                    </div>
                  </li>
                  <li class="media mb-1 mt-2" v-if="lead.formatted_empanelment_done_date">
                    <div class="media-body">
                      <p class="mt-0 mb-1">{{ lead.formatted_empanelment_done_date }}</p>
                    </div>
                  </li>
                  <li class="media mb-1 addressFeild" v-if="lead.comment">
                    <div class="media-body">
                      <p class="mt-0 mb-1">{{ lead.comment }}</p>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="col-4 pl-0 text-right">
                <span class="label-status"> {{ lead.status_name }} </span>
                <span class="d-block mt-2">
                  {{lead.formatted_ncd}}
                </span>
                <span class="d-block text-link mt-2">
                  <router-link :to="{ name: 'Brokeredit', params: { id: lead.uuid } }" tag="div" class="text-link m-0">
                    Update
                  </router-link>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            <h2>Meetings Log</h2>
          </div>
          <div v-if="lead.meetings.length > 0" class="card-body p-3" v-for="(meeting, index) in lead.meetings" :key="index">
            <div class="meetingDate meeting-content">
              <span class="meeting-title ">
                Meeting Date
              </span>
              {{ meeting.meeting_date }}
            </div>
            <div class="meeting-content image-section">
              <span class="meeting-title ">
                Images
              </span>
              <div class="image-list">
                <div v-if="meeting.meeting_attachment_exist" :style="{backgroundImage:'linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('+meeting.meeting_attachment_url+')'}" alt="Attachment" class="meeting-image"><span class="view-image" @click="viewImage(meeting.meeting_attachment_url)">View</span></div>
                <div v-if="meeting.executive_image_url" :style="{backgroundImage:'linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('+meeting.executive_image_url+')'}" alt="Attachment" class="meeting-image"><span class="view-image" @click="viewImage(meeting.executive_image_url)">View Selfie</span></div>
              </div>
            </div>
            <div class="meeting-content">
              <span class="meeting-title ">
                Location
              </span>
              {{ meeting.location }}
            </div>
            <div class="meeting-content" v-if="meeting.comment">
              <span class="meeting-title ">
                Comment
              </span>
              {{ meeting.comment }}
            </div>
          </div>
          <!-- no Message -->
          <div v-else class="card-body p-3 card-message">
            <img src="@/assets/message-icon.svg" alt="" />
            <span class="info" style="float: none">No meetings <br />Click on + to add details</span>
          </div>
        </div>
      </b-container>
      <router-view></router-view>
    </div>
    <MeetingForm :meetingDialog="meetingDialog" :meeting="meeting" />
    <b-modal id="view-image-full" modal-class="view-image-full" centered hide-footer hide-header>
      <div class="w-full d-flex justify-content-end">
        <img src="@/assets/close-icon.svg" width="25" height="25" class="view-image-close-icon" @click="hideImageModal()" />
      </div>
      <img :src="viewedImage" class="img-fluid fullscreen-image" />
    </b-modal>
  </div>
</template>
<script>
import MeetingForm from "./MeetingForm.vue";
import { EMPANELMENT_STATUS_IDS } from "@/assets/scripts/utility.js";
export default {
  name: "BrokerDetails",
  components: {
    MeetingForm,
  },
  data() {
    return {
      updateStatus: false,
      meetingStatus: false,
      meetingDialog: false,
      ariaDescribedby: "",
      canEdit: false,
      step: 0,
      lead: {},
      meeting: {
        date: "",
        attachment: null,
      },
      viewedImage: null
    };
  },
  created() {
    this.fetchBrokerDetail();
  },
  methods: {
    updateBrokerStatus() {
      this.updateStatus = false;
      let uuid = this.$route.params.id;
      this.$axios
        .put(`leads/${uuid}`, { lead: this.lead })
        .then((res) => {
          swal({
            title: "Lead Updated!",
            icon: "success",
          }).then(this.fetchBrokerDetail());
        })
        .catch((err) => {
          if (err.response.status === 500) {
            swal({
              title: "Server Error!",
              icon: "error",
            });
          } else {
            swal({
              title: "Error",
              text: err.response.data.message,
              icon: "error",
            });
          }
        });
    },
    fetchBrokerDetail() {
      let uuid = this.$route.params.id;
      this.$axios.get(`leads/${uuid}`).then((res) => {
        this.lead = res.data.lead;
        this.canEdit = res.data.can_edit_lead
      });
    },
    viewImage(image) {
      this.viewedImage = image;
      this.$nextTick(() => this.$bvModal.show('view-image-full'));
    },
    hideImageModal() {
      this.$bvModal.hide('view-image-full');
      this.viewedImage = null;
    }

  },
};
</script>
<style scoped>
.card-details .broker-name {
  font-size: 16px;
}

.card-details .firm-name {
  font-size: 14px;
}

.label-status {
  border-radius: 18px;
  background: #f2f2f2;
  font-weight: bold;
  font-size: 12px;
  text-align: center;
  letter-spacing: 0.02em;
  padding: 5px 15px;
  display: inline-flex;
  align-content: flex-end;
}

.card-details ul li img {
  margin: 3px 0 0;
}

.card-details ul li p {
  letter-spacing: 0.02em;
  color: #333333;
  opacity: 0.5;
  font-size: 14px;
}

.meeting-title {
  display: block;
  color: #444B4E66;
  margin-bottom: 4px;
}

.meeting-content {
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: #444B4E;
  margin-bottom: 16px;
}

.image-section .image-list {
  display: flex;
  margin-bottom: 16px;
}

.image-section .image-list .meeting-image {
  width: 106px;
  padding-top: 106px;
  border-radius: 6px;
  position: relative;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.image-section .image-list .meeting-image:not(:first-child) {
  margin-left: 15px;
}

.image-section .image-list .view-image {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  width: 100%;
  top: 40%;
  z-index: 50;
  letter-spacing: 0.1px;
  color: #FFFFFF;
  text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.4);
  font-size: 14px;
  font-weight: 500;
}

.fullscreen-image {
  max-height: 100%;
  max-width: 100%;
  width: auto;
  height: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  border-radius: 1px;
}

.view-image-close-icon {
  margin-top: 4px;
  margin-right: 4px;
  margin-bottom: 20px;
  z-index: 50;
}
</style>